
/* VARIANTS COUNTER
 -------------------------------------------*/

let VariantsCounter = function () {
    var incrementButtons = $('.variants-counter-button');
    var countItems = $(".variants-counter");

    var plusQuantity = function (button) {
        if (isNaN(button.currentVal))
            return button.field.val(button.minValue).trigger("change");
        return button.field.val(button.currentVal + 1).trigger("change");
    };

    var minusQuantity = function (button) {
        if (!isNaN(button.currentVal) && button.currentVal > 0)
            return button.field.val(button.currentVal - 1).trigger("change");
        return button.field.val(button.minValue).trigger("change");
    };

    var changeQuantity = function (button) {
        button.field = $(button).siblings('.variants-counter');
        button.currentVal = parseInt(button.field.val());
        button.operator = $(button).data('action');
        button.minValue = button.field.attr('min');

        return button.operator == "minus"
            ? minusQuantity(button)
            : plusQuantity(button);
    };

    var checkAvailable = function (field) {
        field.maxValue = $(field).attr('max');
        field.minValue = $(field).attr('min');
        field.currentVal = parseInt($(field).val());

        if (field.currentVal > field.maxValue) {
            alert('доступное количество на складе ' + field.maxValue + ' шт.');
            $(field).val(field.maxValue);
            return false;
        }
        if (field.currentVal < field.minValue) {
            $(field).val(field.minValue);
            return false;
        }

        return true;
    };

    var init = function () {

        $(document).on('click', '.variants-counter-button', function (event) {
            event.preventDefault();
            changeQuantity(this);
        });
    };

    return {
        init: init,
        validate: checkAvailable,
        hello: function(){console.log('hello');}
    };

}();


export default VariantsCounter;